export type FilterIdentifier =
  | 'CHAINS_TABLE'
  | 'DOORS_TABLE'
  | 'CONTACTS_TABLE'
  | 'DEALS_TABLE'
  | 'ACTIVITY_TABLE_V2'
  | 'COMPANIES_TABLE'
  | 'UNMATCHED_DOORS_TABLE'
  | 'DEALS_PIPELINE_TABLE'
  | 'CNU_TABLE'
  | 'K12_TABLE'
  | 'HOSPITAL_TABLE'
  | 'NURSING_HOME_TABLE'
  | 'ALL_CAMPAIGNS_TABLE'
  | 'EMAILS_TABLE'
  | 'NURSING_HOME_TABLE'
  | 'REBATES_TABLE'
  | 'REBATE_CLAIMS_TABLE'
  | 'LODGING_TABLE'
  | 'LODGING_DOOR_TABLE'
  | 'CONTACT_REQUESTS_TABLE'
  | 'ATTRIBUTION_CODES_TABLE'
  | 'REBATE_ENROLLMENTS_TABLE'
  | 'CONVENIENCE_DOOR_TABLE'
  | 'CONVENIENCE_TABLE'
  | 'NOTES_TABLE'
  | 'SELECT_LOCATIONS'
  | 'DOOR_NOTES_TABLE'
  | 'REMINDERS_TABLE'
  | 'PRODUCTS_TABLE'
  | 'VARIANTS_TABLE'
  | 'AUTOMATIONS_TABLE'
  | 'DOCUMENTS_ALL_TABLE'
  | 'DOCUMENTS_PRODUCT_TABLE'
  | 'DOCUMENTS_COMPANY_TABLE'
  | 'DOCUMENTS_MODAL'
  | 'DOCUMENTS_IMAGE_PICKER'
  | 'MY_SAMPLES_TABLE'
  | 'SAMPLES_TABLE'
  | 'MOBILE_DOORS_LIST'
  | 'MOBILE_SAMPLES_TABLE'
  | 'MOBILE_REMINDERS_TABLE'
  | 'MOBILE_NOTES_TABLE'
  | 'SELECT_PRODUCT_VARIANT'
  | 'EMAIL_THREADS_TABLE'

export const SavedViewTableLabels: Record<FilterIdentifier, string> = {
  CHAINS_TABLE: 'Restaurant Chains',
  DOORS_TABLE: 'Restaurant Doors',
  CONTACTS_TABLE: 'Contacts',
  DEALS_TABLE: 'Deals',
  ACTIVITY_TABLE_V2: 'Activity',
  DEALS_PIPELINE_TABLE: 'Deals Pipeline',
  CNU_TABLE: 'College & Universities',
  K12_TABLE: 'K12 Districts',
  HOSPITAL_TABLE: 'Hospitals',
  COMPANIES_TABLE: 'Generic Company', // Wont be used
  UNMATCHED_DOORS_TABLE: 'Unmatched Doors', // Won't be used
  ALL_CAMPAIGNS_TABLE: 'Campaigns',
  NURSING_HOME_TABLE: 'Nursing Homes',
  EMAILS_TABLE: 'Emails',
  REBATES_TABLE: 'Rebates', // TODO rename to rebate_offers
  REBATE_CLAIMS_TABLE: 'Rebate Claims',
  LODGING_TABLE: 'Lodging Chains',
  LODGING_DOOR_TABLE: 'Lodging Doors',
  CONVENIENCE_DOOR_TABLE: 'Convenience Doors',
  CONVENIENCE_TABLE: 'Convenience Chains',
  CONTACT_REQUESTS_TABLE: 'Contact Requests',
  ATTRIBUTION_CODES_TABLE: 'Attribution Codes',
  REBATE_ENROLLMENTS_TABLE: 'Rebate Enrollments',
  NOTES_TABLE: 'Notes',
  SELECT_LOCATIONS: 'Select Locations for Deal',
  DOOR_NOTES_TABLE: 'Door Notes',
  REMINDERS_TABLE: 'Reminders',
  PRODUCTS_TABLE: 'Products',
  VARIANTS_TABLE: 'Variants',
  AUTOMATIONS_TABLE: 'Automations',
  DOCUMENTS_ALL_TABLE: 'Documents - All',
  DOCUMENTS_PRODUCT_TABLE: 'Documents - Product',
  DOCUMENTS_COMPANY_TABLE: 'Documents - Company',
  DOCUMENTS_MODAL: 'Documents - Modal',
  DOCUMENTS_IMAGE_PICKER: 'Documents - Image Picker',
  MY_SAMPLES_TABLE: 'My Samples',
  SAMPLES_TABLE: 'Samples',
  MOBILE_DOORS_LIST: 'Mobile Doors List',
  MOBILE_SAMPLES_TABLE: 'Mobile Samples',
  MOBILE_REMINDERS_TABLE: 'Mobile Reminders',
  MOBILE_NOTES_TABLE: 'Mobile Notes',
  SELECT_PRODUCT_VARIANT: 'Select Product Variant',
  EMAIL_THREADS_TABLE: 'Email Threads',
}

export interface SavedView {
  id: number
  name: string
  identifier: FilterIdentifier
  payload: Record<any, any>
  shared: boolean
  user: {
    first_name: string
    last_name: string
  }
}

export interface SavedViewUpdate {
  name: string
  shared: boolean
}

export interface SavedViewCreate {
  name: string
  identifier: FilterIdentifier
  shared: boolean
  payload: Record<any, any>
}
